var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { colors } from '../../abstracts';
import { StyledStepText, StyledStepSubtext, StyledStepTag, StepTextGroup, } from './elements';
var subTitleMaxHeight = 2.375;
var tagHeight = 1.25;
var getIconUrl = function (state, size) {
    var icon = {
        warning: 'warning.svg',
        complete: "checkmark-".concat(size, ".svg")
    }[state];
    return "https://assets.asurion-ui.my.asurion53.com/icons/component-specific/progress-stepper/".concat(icon);
};
var calcPercentage = function (part, total) {
    return total > 0 ? (100 * part) / total : 0;
};
var StyledStepListItem = styled.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  border-radius: 50%;\n  border: 0.125rem solid ", ";\n  display: inline-flex;\n  ", "\n\n  ", "\n\n    ", "\n\n  ", "\n    \n    &:not(:last-child) {\n    .progress-stepper-step-connector {\n      display: block;\n    }\n  }\n"], ["\n  position: relative;\n  border-radius: 50%;\n  border: 0.125rem solid ", ";\n  display: inline-flex;\n  ", "\n\n  ", "\n\n    ", "\n\n  ", "\n    \n    &:not(:last-child) {\n    .progress-stepper-step-connector {\n      display: block;\n    }\n  }\n"])), colors.neutralDeeper, function (_a) {
    var size = _a.size;
    var diam;
    if (size === 'small') {
        diam = '0.75rem';
    }
    else if (size === 'medium') {
        diam = '1.25rem';
    }
    return "\n      height: ".concat(diam, ";\n      width: ").concat(diam, ";\n      min-width: ").concat(diam, ";\n    ");
}, function (_a) {
    var state = _a.state;
    return state === 'inprogress' &&
        "\n      border: 0.125rem solid ".concat(colors.black, ";\n      .progress-stepper-step-inner-circle {\n        opacity: 1;\n      }\n    ");
}, function (_a) {
    var state = _a.state;
    return state === 'warning' &&
        "\n      border: 0.125rem solid ".concat(colors.black, ";\n      .progress-stepper-step-inner-circle {\n        opacity: 1;\n        transform: scale(1.66667);\n        transition: all 0.3s;\n      }\n    ");
}, function (_a) {
    var state = _a.state;
    return state === 'complete' &&
        "\n      border: 0.125rem solid ".concat(colors.black, ";\n      .progress-stepper-step-inner-circle {\n        opacity: 1;\n        transform: scale(2);\n        transition: all 0.3s;\n      }\n    ");
});
var InnerCircle = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  border-radius: 50%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  background-color: ", ";\n  opacity: 0;\n  transition: opacity 0.5s, scale 0.5s, color 0.3s;\n\n  ", "\n"], ["\n  position: absolute;\n  border-radius: 50%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  background-color: ", ";\n  opacity: 0;\n  transition: opacity 0.5s, scale 0.5s, color 0.3s;\n\n  ", "\n"])), function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var size = _a.size;
    var diam;
    if (size === 'small') {
        diam = '0.5rem';
    }
    else if (size === 'medium') {
        diam = '0.75rem';
    }
    return "\n      height: ".concat(diam, ";\n      width: ").concat(diam, ";\n    ");
});
var StyledProgressIcon = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  opacity: 0;\n  position: absolute;\n  top: -0.125rem;\n  right: -0.125rem;\n  transform: scale(0.65);\n  opacity: 1;\n  ", ";\n  transition: opacity 0.5s, scale 0.5s;\n\n  ", "\n"], ["\n  opacity: 0;\n  position: absolute;\n  top: -0.125rem;\n  right: -0.125rem;\n  transform: scale(0.65);\n  opacity: 1;\n  ", ";\n  transition: opacity 0.5s, scale 0.5s;\n\n  ", "\n"])), function (_a) {
    var state = _a.state;
    return state == 'complete' && "filter: invert(1)";
}, function (_a) {
    var size = _a.size;
    var diam;
    if (size === 'small') {
        diam = '0.75rem';
    }
    else if (size === 'medium') {
        diam = '1rem';
    }
    return (diam &&
        "\n        height: ".concat(diam, ";\n        width: ").concat(diam, ";\n      "));
});
var Connector = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background-color: ", ";\n  ", "\n"], ["\n  background-color: ", ";\n  ", "\n"])), colors.neutralDeeper, function (_a) {
    var orientation = _a.orientation, size = _a.size, isPacked = _a.isPacked;
    return orientation == 'vertical'
        ? "\n          height: ".concat(isPacked
            ? 'inherit'
            : "".concat((6.031 + subTitleMaxHeight + tagHeight).toFixed(2), "rem"), ";\n          width: 0.125rem;\n          margin-left: ").concat(size == 'small' ? '0.438rem' : '0.688rem', ";\n        ")
        : "\n          height: 0.125rem;\n          width: 100%;\n        ";
});
var ConnectorTextGroup = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  ", ";\n"], ["\n  display: flex;\n  ", ";\n"])), function (_a) {
    var orientation = _a.orientation;
    return orientation == 'vertical'
        ? "\n          flex-direction: row;\n        "
        : "\n          flex-direction: column;\n          width: 100%;\n          margin-top: auto;\n          margin-bottom: auto;\n        ";
});
var ConnectorFill = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: relative;\n  ", "\n  background-color: ", ";\n\n  &:after {\n    content: '';\n    width: 0.375rem;\n    height: 0.375rem;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: ", ";\n    border-radius: 50%;\n    margin: auto 0;\n    background-color: currentColor;\n    opacity: 0;\n    transition: opacity 0.5s;\n  }\n\n  ", "\n"], ["\n  position: relative;\n  ", "\n  background-color: ", ";\n\n  &:after {\n    content: '';\n    width: 0.375rem;\n    height: 0.375rem;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: ", ";\n    border-radius: 50%;\n    margin: auto 0;\n    background-color: currentColor;\n    opacity: 0;\n    transition: opacity 0.5s;\n  }\n\n  ", "\n"])), function (_a) {
    var orientation = _a.orientation, connectorFillPercentage = _a.connectorFillPercentage;
    return orientation == 'vertical'
        ? "\n          height: ".concat(connectorFillPercentage, "%;\n          width: 0.125rem;\n          left: 0;\n          transition: height 0.2s;\n        ")
        : "\n          width: ".concat(connectorFillPercentage, "%;\n          height: 0.125rem;\n          left: 0;\n          transition: width 0.2s;\n        ");
}, colors.black, function (_a) {
    var orientation = _a.orientation;
    return orientation == 'vertical' ? '-0.125rem' : '-0.25rem';
}, function (_a) {
    var showDot = _a.showDot;
    return showDot &&
        "\n      &:after {\n        opacity: 1;\n      }\n    ";
});
export var ListItem = function (_a) {
    var _b = _a.state, state = _b === void 0 ? 'incomplete' : _b, _c = _a.subSteps, subSteps = _c === void 0 ? [] : _c, isPacked = _a.isPacked, stepTitle = _a.stepTitle, stepSubTitle = _a.stepSubTitle, tagType = _a.tagType, tagText = _a.tagText, tagIcon = _a.tagIcon, index = _a.index, stepsAmount = _a.stepsAmount, orientation = _a.orientation, _d = _a.size, size = _d === void 0 ? 'small' : _d;
    var connectorFillPercentage = useMemo(function () {
        if (!Array.isArray(subSteps) || subSteps.length === 0) {
            return state === 'complete' ? 100 : 0;
        }
        if (subSteps[subSteps.length - 1].state === 'complete') {
            return 100;
        }
        var activeSubSteps = subSteps.filter(function (subStep) { return subStep.state !== 'incomplete'; }).length;
        return calcPercentage(activeSubSteps, subSteps.length + 1);
    }, [state, subSteps]);
    var isLast = useMemo(function () { return index === stepsAmount - 1; }, [index, stepsAmount]);
    var showConnectorDot = useMemo(function () { return connectorFillPercentage > 0 && connectorFillPercentage < 100; }, [connectorFillPercentage]);
    var stateWithSubSteps = useMemo(function () {
        return state === 'complete' && connectorFillPercentage < 100
            ? 'inprogress'
            : state;
    }, [connectorFillPercentage, state]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledStepListItem, { state: stateWithSubSteps, "data-testid": "progress-stepper-step-".concat(index), size: size },
            React.createElement(InnerCircle, { className: "progress-stepper-step-inner-circle", "data-testid": "progress-stepper-step-".concat(index, "-circle-").concat(state), state: state, size: size, color: state == 'warning' ? colors.white : colors.black }, (state === 'complete' || state === 'warning') && (React.createElement(StyledProgressIcon, { src: getIconUrl(state, size), alt: "Step ".concat(state), state: stateWithSubSteps, size: size })))),
        React.createElement(ConnectorTextGroup, { orientation: orientation },
            !isLast && (React.createElement(Connector, { className: "progress-stepper-step-connector", size: size, isPacked: isPacked, stepsAmount: stepsAmount, orientation: orientation, "data-testid": "progress-stepper-step-".concat(index, "-connector") },
                React.createElement(ConnectorFill, { showDot: showConnectorDot, connectorFillPercentage: connectorFillPercentage, orientation: orientation, "data-testid": "progress-stepper-step-".concat(index, "-connector-fill") }))),
            orientation == 'vertical' && (React.createElement(StepTextGroup, { isLast: isLast, size: size },
                stepTitle && (React.createElement(StyledStepText, { forwardedAs: "h2", size: 3, iconSize: size, weight: "feather", "data-testid": "step-title-".concat(index) }, stepTitle)),
                stepSubTitle && (React.createElement(StyledStepSubtext, { forwardedAs: 'h3', size: 2, iconSize: size, weight: "base", "data-testid": "step-subtitle-".concat(index) }, stepSubTitle)),
                tagText && (React.createElement(StyledStepTag, { size: "regular", type: tagType, text: tagText, iconSrc: tagIcon })))))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
